import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Col, Grid, Icon, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import styles from 'components/Breadcrumbs/breadcrumbs.module.scss'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import clsx from 'clsx'

const Breadcrumbs = ({ className, links = [] }) => {
  const { sm: isSmallDevice } = useBreakpoint()
  const count = useMemo(() => links.length, [links])
  const filteredLinks = useMemo(
    () => (isSmallDevice && count > 1 ? [...links].splice(-1, 1) : links),
    [links, isSmallDevice, count],
  )

  return (
    <Grid
      className={clsx(styles['breadcrumbs'], className)}
      gap={8}
      direction={'row'}
      alignContent={'center'}
      alignItems={'center'}
    >
      {filteredLinks.map((link, index) => (
        <React.Fragment key={'breadcrumb-segment-' + index}>
          <Typography
            className={clsx(styles['breadcrumbs__link'], {
              [styles['breadcrumbs__link_small']]: isSmallDevice,
            })}
            to={link.to}
            variant={'Body-15'}
            component={link.to ? Link : 'span'}
          >
            <Grid gap={8} alignItems={'center'}>
              {isSmallDevice && (
                <Icon
                  color={'inherit'}
                  className={styles['breadcrumbs__arrow']}
                  name={'arrow-left'}
                  size={'sm'}
                />
              )}
              <Col>{link.title}</Col>
              {!isSmallDevice && (
                <Icon
                  color={'inherit'}
                  className={styles['breadcrumbs__arrow']}
                  name={'arrow-right'}
                  size={'sm'}
                />
              )}
            </Grid>
          </Typography>
        </React.Fragment>
      ))}
    </Grid>
  )
}

Breadcrumbs.propTypes = {
  className: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      to: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    }),
  ),
}

export default Breadcrumbs
